// src/shared/header/Header.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";
import logo from "../../assets/11.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header">
      {/* Logo + Name */}
      <div className="logo-name">
        <img src={logo} alt="Logo" className="logo-img" />
        <div className="logo-texts">
          <span className="logo-text">Safety Zone</span>
          <span className="logo-text2">Express</span>
        </div>
      </div>

      {/* Hamburger Icon */}
      <div
        className={`hamburger ${isOpen ? "active" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation */}
      <nav className={`nav ${isOpen ? "open" : ""}`}>
        <Link to="/" onClick={closeMenu}>
          الرئيسية
        </Link>

        {/* Dropdown خدماتنا */}
        <div
          className="dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <span className="dropdown-toggle">خدماتنا ▾</span>
          <div className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
          <Link to="/air-shipping" onClick={closeMenu}>
              شحن جوي
            </Link>
            <Link to="/land-shipping" onClick={closeMenu}>
              شحن بري
            </Link>
            <Link to="/sea-shipping" onClick={closeMenu}>
              شحن بحري
            </Link>

          </div>
        </div>

        <Link to="/about" onClick={closeMenu}>
          من نحن
        </Link>

        <a href="tel:+201028510553" className="contact-btn" onClick={closeMenu}>
          اتصل بنا
        </a>
      </nav>
    </header>
  );
};

export default Header;
